export enum LayoutElementsEnum {
	bottomBar = 'bottomBar',
	floatingSidebar = 'floatingSidebar',
	patientCardVisible = 'patientCardVisible'
}
